import { REDUX_CLASS_NAME_TO_DOMAIN } from 'modules/redux/constants'

function getDefaultDomainListPath (instance, domainPath) {
  const domainName = domainPath || REDUX_CLASS_NAME_TO_DOMAIN[instance.className]
  return `${domainName}.all`
}

export default getDefaultDomainListPath
